import {
    trackEcommerce,
    trackEvent,
    trackingConstants,
    eventNameConstants,
    stepInteractionConstants,
    type EcomProduct,
} from 'dibs-tracking';

import { type UserRecommendationsRecommendationTile_item$data } from './__generated__/UserRecommendationsRecommendationTile_item.graphql.ts';

const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST, EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { STEP_INTERACTION_RECOMMENDATION_VIEW_ALL_CLICK, STEP_INTERACTION_VIEW_LESS_CLICKED } =
    stepInteractionConstants;

const toEcomProduct = (
    item: UserRecommendationsRecommendationTile_item$data,
    index: number,
    trackingTrigger: string
): EcomProduct => {
    const { browseUrl, categoryCode, ecommerceTrackingParams, seller, serviceId, title } = item;

    return {
        id: serviceId,
        name: title,
        list: trackingTrigger,
        position: index + 1,
        categoryCode,
        category: browseUrl,
        brand: seller?.serviceId,
        ...ecommerceTrackingParams,
    };
};

export const trackUserRecommendationsItemImpression = ({
    item,
    index,
    trackingTrigger,
}: {
    item: UserRecommendationsRecommendationTile_item$data;
    index: number;
    trackingTrigger: string;
}): void => {
    if (!item.serviceId) {
        return;
    }

    trackEcommerce({
        type: ECOM_PRODUCT_IMPRESSION,
        eventName: EVENT_VIEW_ITEM_LIST,
        trigger: trackingTrigger,
        products: [toEcomProduct(item, index, trackingTrigger)],
    });
};

export const trackUserRecommendationsItemClick = ({
    item,
    index,
    trackingTrigger,
}: {
    item: UserRecommendationsRecommendationTile_item$data;
    index: number;
    trackingTrigger: string;
}): void => {
    if (!item.serviceId) {
        return;
    }

    trackEcommerce({
        type: ECOM_PRODUCT_CLICK,
        eventName: EVENT_SELECT_ITEM,
        trigger: trackingTrigger,
        actionField: { list: trackingTrigger, itemId: item.serviceId },
        products: [toEcomProduct(item, index, trackingTrigger)],
    });
};

const sharedTrackingViewMoreToggleParams = (trackingTrigger: string): Record<string, string> => ({
    eventName: EVENT_PRODUCT_INTERACTION,
    interaction_type: trackingTrigger,
    trigger: trackingTrigger,
});

export const trackUserRecommendationsViewMoreClick = (trackingTrigger: string): void => {
    trackEvent({
        ...sharedTrackingViewMoreToggleParams(trackingTrigger),
        step_interaction_name: STEP_INTERACTION_RECOMMENDATION_VIEW_ALL_CLICK,
    });
};

export const trackUserRecommendationsViewLessClick = (trackingTrigger: string): void => {
    trackEvent({
        ...sharedTrackingViewMoreToggleParams(trackingTrigger),
        step_interaction_name: STEP_INTERACTION_VIEW_LESS_CLICKED,
    });
};
